import http from './http';

const ENDPOINTS = {
  // OPD Admission endpoints
  ADMISSIONS: '/api/v1/opd-admissions',
  ADMISSION_BY_ID: (id) => `/api/v1/opd-admissions/${id}`,
  ADMISSION_STATISTICS: '/api/v1/opd-admissions/statistics',
  DISCHARGE_PATIENT: (id) => `/api/v1/opd-admissions/${id}/discharge`,
  TRANSFER_PATIENT: (id) => `/api/v1/opd-admissions/${id}/transfer`,
  ADD_DAILY_NOTE: (id) => `/api/v1/opd-admissions/${id}/daily-notes`,
  PATIENT_ADMISSION_HISTORY: (patientId) => `/api/v1/opd-admissions/patient/${patientId}/history`,
};

/**
 * OPD Admission Management API Service
 */
export const opdAdmissionAPI = {
  /**
   * Admit a patient to OPD
   */
  admitPatient: async (admissionData) => {
    const response = await http.post(ENDPOINTS.ADMISSIONS, admissionData);
    return response.data;
  },

  /**
   * Get all OPD admissions with pagination and filtering
   */
  getAdmissions: async (params = {}) => {
    const response = await http.get(ENDPOINTS.ADMISSIONS, { params });
    return response.data;
  },

  /**
   * Get admission statistics
   */
  getStatistics: async (params = {}) => {
    const response = await http.get(ENDPOINTS.ADMISSION_STATISTICS, { params });
    return response.data;
  },

  /**
   * Get admission by ID
   */
  getAdmissionById: async (id) => {
    const response = await http.get(ENDPOINTS.ADMISSION_BY_ID(id));
    return response.data;
  },

  /**
   * Update admission details
   */
  updateAdmission: async (id, updateData) => {
    const response = await http.put(ENDPOINTS.ADMISSION_BY_ID(id), updateData);
    return response.data;
  },

  /**
   * Discharge a patient from OPD
   */
  dischargePatient: async (id, dischargeData) => {
    const response = await http.post(ENDPOINTS.DISCHARGE_PATIENT(id), dischargeData);
    return response.data;
  },

  /**
   * Transfer patient to another department/ward
   */
  transferPatient: async (id, transferData) => {
    const response = await http.post(ENDPOINTS.TRANSFER_PATIENT(id), transferData);
    return response.data;
  },

  /**
   * Add daily note to admission
   */
  addDailyNote: async (id, noteData) => {
    const response = await http.post(ENDPOINTS.ADD_DAILY_NOTE(id), noteData);
    return response.data;
  },

  /**
   * Get patient's admission history
   */
  getPatientAdmissionHistory: async (patientId, params = {}) => {
    const response = await http.get(ENDPOINTS.PATIENT_ADMISSION_HISTORY(patientId), { params });
    return response.data;
  }
};

export default opdAdmissionAPI;